/* CLAVAKIT storefront behaviour. No framework. Everything degrades: without JS
   the page is fully readable, forms post natively, details/summary open.
   window.CLAVAKIT (set inline in <head>) carries per-page config:
     { nativeForms, cartUrl, productHandle, variants:[{key,name,img,id}], sale:{ends} } */
(function () {
  'use strict';
  var d = document, w = window;
  var cfg = w.CLAVAKIT || {};
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var reduced = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  d.documentElement.classList.add('js');

  /* ---- header: mobile menu ------------------------------------------------ */
  var toggle = $('.menu-toggle'), mnav = $('.mobile-nav');
  if (toggle && mnav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mnav.hidden = open;
      if (!open) { var first = $('a', mnav); first && first.focus(); }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { toggle.click(); toggle.focus(); }
    });
  }

  /* ---- reveal on scroll ----------------------------------------------------- */
  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in w && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- sale end date (owner-set; never a per-load countdown) ---------------- */
  var saleEls = $$('[data-sale-ends]');
  if (saleEls.length && cfg.sale && cfg.sale.ends) {
    var ends = new Date(cfg.sale.ends + 'T23:59:59');
    if (!isNaN(ends)) {
      var days = Math.ceil((ends - new Date()) / 864e5);
      var when = days <= 0 ? null : days === 1 ? 'tomorrow' : ends.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      saleEls.forEach(function (el) {
        /* the markup says "Ends <date>", "ends <date>" or just "<date>": keep its own lead-in */
        var t = el.textContent.trim(), lead = /^Ends/.test(t) ? 'Ends ' : /^ends/.test(t) ? 'ends ' : '';
        el.textContent = when ? lead + when : (lead === 'Ends ' ? 'Sale ended' : lead === 'ends ' ? 'sale ended' : 'today');
      });
    }
  }

  /* ---- toast ---------------------------------------------------------------- */
  var toast = $('.toast'), toastT;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  /* ---- product page --------------------------------------------------------- */
  var pdp = $('.pdp');
  if (pdp) {
    var mainImg = $('.gallery__main img'), thumbs = $$('.gallery__thumbs button');
    var variantInputs = $$('.variant-list input'), chosenOut = $('[data-chosen]');
    var qtyInput = $('.qty input'), forms = $$('form[data-cart]');

    function showImage(src, srcset, alt) {
      if (!mainImg || !src) return;
      mainImg.classList.add('is-loading');
      var pre = new Image();
      pre.onload = function () {
        mainImg.src = src; if (srcset) mainImg.srcset = srcset; if (alt) mainImg.alt = alt;
        mainImg.classList.remove('is-loading');
      };
      pre.onerror = function () { mainImg.classList.remove('is-loading'); };
      pre.src = src;
    }
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
        b.setAttribute('aria-current', 'true');
        showImage(b.dataset.src, b.dataset.srcset, b.dataset.alt);
      });
    });
    function applyVariant(inp) {
      if (chosenOut) chosenOut.value = inp.dataset.name || '';
      if (inp.dataset.src) {
        showImage(inp.dataset.src, inp.dataset.srcset, inp.dataset.alt);
        thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
        var t = thumbs.filter(function (x) { return x.dataset.key === inp.value; })[0];
        if (t) t.setAttribute('aria-current', 'true');
      }
      forms.forEach(function (f) { var idf = $('input[name="id"]', f); if (idf && inp.dataset.id) idf.value = inp.dataset.id; });
      try { history.replaceState(null, '', '#' + inp.value); } catch (e) {}
    }
    variantInputs.forEach(function (inp) { inp.addEventListener('change', function () { applyVariant(inp); }); });
    var fromHash = location.hash.slice(1);
    var initial = variantInputs.filter(function (i) { return i.value === fromHash; })[0] || variantInputs.filter(function (i) { return i.checked; })[0];
    if (initial) { initial.checked = true; applyVariant(initial); }

    $$('.qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        v = Math.min(10, Math.max(1, v + (b.dataset.step === '-' ? -1 : 1)));
        qtyInput.value = v;
        forms.forEach(function (f) { var q = $('input[name="quantity"]', f); if (q) q.value = v; });
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var v = Math.min(10, Math.max(1, parseInt(qtyInput.value, 10) || 1)); qtyInput.value = v;
      forms.forEach(function (f) { var q = $('input[name="quantity"]', f); if (q) q.value = v; });
    });

    /* sticky bar: visible once the buy box's own button has scrolled off */
    var sticky = $('.sticky-atc'), buyBtn = $('.pdp__buy .btn--primary');
    if (sticky && buyBtn && 'IntersectionObserver' in w) {
      d.body.classList.add('has-sticky');
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(buyBtn);
    }

    /* add to cart: static site fakes it with a toast; Shopify posts to /cart/add */
    forms.forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var btn = $('button[type="submit"]', f);
        if (cfg.nativeForms) { if (btn) btn.setAttribute('aria-busy', 'true'); return; }
        e.preventDefault();
        var name = chosenOut ? chosenOut.value : '';
        if (btn) { btn.setAttribute('aria-busy', 'true'); }
        setTimeout(function () {
          if (btn) btn.removeAttribute('aria-busy');
          var count = $('.cart-count'); if (count) { count.textContent = String((parseInt(count.textContent, 10) || 0) + (parseInt(qtyInput && qtyInput.value, 10) || 1)); count.hidden = false; }
          say('Added ' + (name ? name + ' ' : '') + 'to cart');
          d.dispatchEvent(new CustomEvent('clavakit:added', { detail: { variant: name } }));
        }, 350);
      });
    });

    /* share */
    var shareBtn = $('[data-share]');
    if (shareBtn) {
      if (navigator.share) {
        shareBtn.addEventListener('click', function () { navigator.share({ title: d.title, url: location.href }).catch(function () {}); });
      } else {
        shareBtn.addEventListener('click', function () {
          (navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject()).then(function () { say('Link copied'); }, function () { say(location.href); });
        });
      }
    }
  }

  /* ---- try-on cards: the model stays, only the print changes ------------------- */
  $$('[data-tryon]').forEach(function (card) {
    var img = $('.tryon__stage img', card), thumbs = $$('.tryon__thumbs button', card);
    var nameEl = $('[data-tryon-name]', card), countEl = $('[data-tryon-count]', card), cta = $('[data-tryon-cta]', card);
    var i = Math.max(0, thumbs.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; }));
    if (!img || thumbs.length < 2) return;
    function preload(k) { var b = thumbs[(k + thumbs.length) % thumbs.length]; if (b && b.dataset.src) { var p = new Image(); p.src = b.dataset.src; } }
    function go(k, focusThumb) {
      i = (k + thumbs.length) % thumbs.length;
      var b = thumbs[i];
      thumbs.forEach(function (x, n) { x.setAttribute('aria-pressed', String(n === i)); });
      img.classList.add('is-loading');
      var pre = new Image();
      pre.onload = pre.onerror = function () { img.src = b.dataset.src; img.alt = b.dataset.alt || ''; img.classList.remove('is-loading'); };
      pre.src = b.dataset.src;
      if (nameEl) nameEl.textContent = b.dataset.name || '';
      if (countEl) countEl.textContent = (i + 1) + ' / ' + thumbs.length;
      if (cta) cta.href = cta.href.split('#')[0] + '#' + (b.dataset.key || '');
      preload(i + 1); preload(i - 1);
      if (focusThumb) b.focus();
    }
    $('.tryon__arrow--prev', card).addEventListener('click', function () { go(i - 1); });
    $('.tryon__arrow--next', card).addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (b, n) { b.addEventListener('click', function () { go(n); }); });
    card.addEventListener('keydown', function (e) {
      if (e.target.closest('.tryon__thumbs') || e.target.closest('.tryon__arrow')) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1, true); }
      }
    });
    var x0 = null;
    img.parentNode.addEventListener('pointerdown', function (e) { x0 = e.clientX; }, { passive: true });
    img.parentNode.addEventListener('pointerup', function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 40) go(e.clientX < x0 ? i + 1 : i - 1); x0 = null; }, { passive: true });
    preload(i + 1);
  });

  /* ---- orbit carousel: masks circle the model, the front one lands on his face ----
     One state object (rot, target). Every handler only changes the target; one
     layout() derives every item's position, depth, z-order and the active print. */
  $$('[data-orbit]').forEach(function (card) {
    var stage = $('.orbit', card), modelImg = $('.orbit__model img', card), items = $$('.orbit__item', card);
    var nameEl = $('[data-orbit-name]', card), countEl = $('[data-orbit-count]', card), cta = $('[data-orbit-cta]', card), pauseBtn = $('.orbit__pause', card);
    var N = items.length; if (!stage || !modelImg || N < 3) return;
    var step = (Math.PI * 2) / N, st = { rot: 0, target: 0, active: 0, raf: 0, W: 0, H: 0 };
    var interacted = false, paused = false, inView = false, timer = 0;
    stage.classList.add('is-orbit');

    function measure() { st.W = stage.clientWidth; st.H = stage.clientHeight; }
    function layout() {
      var itemW = st.W * 0.25;
      for (var k = 0; k < N; k++) {
        var a = k * step + st.rot, depth = Math.cos(a);                 // 1 = front, -1 = back
        var x = st.W / 2 + Math.sin(a) * st.W * 0.40 - itemW / 2;
        var front = (depth + 1) / 2;
        var y = st.H * (0.12 + 0.53 * front);                             // back: up behind the head; front: chest height
        var s = 0.50 + 0.50 * front;
        var el = items[k];
        el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + s.toFixed(3) + ')';
        el.style.zIndex = String(depth > 0.15 ? 60 + Math.round(depth * 20) : 10 + Math.round(front * 20));
        el.style.opacity = (0.30 + 0.70 * front).toFixed(3);
        el.style.filter = 'brightness(' + (0.45 + 0.55 * front).toFixed(2) + ')' + (depth < -0.2 ? ' blur(1.5px)' : '');
      }
    }
    function tick() {
      var d = st.target - st.rot;
      if (Math.abs(d) < 0.0008) { st.rot = st.target; st.raf = 0; layout(); return; }
      st.rot += d * 0.13; layout(); st.raf = requestAnimationFrame(tick);
    }
    function run() { if (reduced) { st.rot = st.target; layout(); return; } if (!st.raf) st.raf = requestAnimationFrame(tick); }
    function setActive(idx) {
      idx = ((idx % N) + N) % N; if (idx === st.active && modelImg.dataset.ready) return;
      st.active = idx; modelImg.dataset.ready = '1';
      var b = items[idx];
      items.forEach(function (x, n) { x.setAttribute('aria-pressed', String(n === idx)); });
      modelImg.classList.add('is-loading');
      var pre = new Image();
      pre.onload = pre.onerror = function () { if (st.active !== idx) return; modelImg.src = b.dataset.src; modelImg.removeAttribute('srcset'); modelImg.alt = b.dataset.alt || ''; modelImg.classList.remove('is-loading'); };
      pre.src = b.dataset.src;
      if (nameEl) nameEl.textContent = b.dataset.name || '';
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + N;
      if (cta) cta.href = cta.href.split('#')[0] + '#' + (b.dataset.key || '');
      [idx + 1, idx - 1].forEach(function (n) { var o = items[((n % N) + N) % N]; var p = new Image(); p.src = o.dataset.src; });
    }
    function goTo(idx) {                                   // turn the shortest way so item idx comes to the front
      var want = -idx * step, cur = st.target;
      var diff = ((want - cur) % (Math.PI * 2) + Math.PI * 3) % (Math.PI * 2) - Math.PI;
      st.target = cur + diff; setActive(Math.round(-st.target / step)); run();
    }
    function nudge(dir) { st.target -= dir * step; setActive(Math.round(-st.target / step)); run(); }
    function userDid() { interacted = true; stopAuto(); if (pauseBtn) pauseBtn.hidden = true; }

    $('.orbit__arrow--prev', card).addEventListener('click', function () { userDid(); nudge(-1); });
    $('.orbit__arrow--next', card).addEventListener('click', function () { userDid(); nudge(1); });
    var dragMoved = false;
    items.forEach(function (b, n) { b.addEventListener('click', function () { if (dragMoved) return; userDid(); goTo(n); }); });
    card.addEventListener('keydown', function (e) {
      if (!e.target.closest('.orbit')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); userDid(); nudge(1); items[st.active].focus({ preventScroll: true }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); userDid(); nudge(-1); items[st.active].focus({ preventScroll: true }); }
    });
    /* drag / swipe turns the ring, release snaps to the nearest mask */
    var drag = null;
    stage.addEventListener('pointerdown', function (e) { if (e.target.closest('.orbit__arrow, .orbit__pause')) return; drag = { x: e.clientX, rot: st.target }; dragMoved = false; });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return; var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 6) { dragMoved = true; userDid(); stage.classList.add('is-dragging'); st.target = drag.rot + (dx / st.W) * Math.PI * 1.1; st.rot = st.target; layout(); }
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return; drag = null; stage.classList.remove('is-dragging');
      if (dragMoved) { st.target = Math.round(st.target / step) * step; setActive(Math.round(-st.target / step)); run(); setTimeout(function () { dragMoved = false; }, 0); }
    });

    /* gentle auto-rotation until the first interaction; pausable; only while visible */
    function stopAuto() { clearInterval(timer); timer = 0; }
    function startAuto() { if (reduced || interacted || paused || timer || !inView) return; timer = setInterval(function () { if (!d.hidden) nudge(1); }, 3200); }
    if (pauseBtn && !reduced) {
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function () { paused = !paused; pauseBtn.setAttribute('aria-pressed', String(paused)); pauseBtn.setAttribute('aria-label', paused ? 'Resume rotation' : 'Pause rotation'); paused ? stopAuto() : startAuto(); });
    }
    stage.addEventListener('pointerenter', stopAuto); stage.addEventListener('pointerleave', startAuto);
    stage.addEventListener('focusin', stopAuto); stage.addEventListener('focusout', startAuto);
    if ('IntersectionObserver' in w) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; inView ? startAuto() : stopAuto(); }, { threshold: 0.4 }).observe(stage);

    /* ember light follows a fine pointer: handlers store the position, one rAF writes it */
    if (!reduced && w.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var glow = { x: 50, y: 45, raf: 0 };
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        glow.x = ((e.clientX - r.left) / r.width) * 100; glow.y = ((e.clientY - r.top) / r.height) * 100;
        if (!glow.raf) glow.raf = requestAnimationFrame(function () { glow.raf = 0; stage.style.setProperty('--mx', glow.x.toFixed(1) + '%'); stage.style.setProperty('--my', glow.y.toFixed(1) + '%'); });
        stage.classList.add('has-pointer');
      });
      stage.addEventListener('pointerleave', function () { stage.classList.remove('has-pointer'); });
    }

    w.addEventListener('resize', function () { measure(); layout(); });
    measure(); layout(); setActive(0);
  });

  /* ---- bundle tiers: live price for the chosen quantity (cart count included: mix & match) */
  (function () {
    var out = $('[data-tier-total]'), qty = $('.qty input'), list = $('[data-tiers-live]');
    if (!out || !qty || !cfg.tiers) return;
    var sym = cfg.currency || '$';
    function fmt(c) { return sym + (c / 100).toFixed(2); }
    function update() {
      var q = Math.max(1, parseInt(qty.value, 10) || 1), inCart = parseInt(cfg.cartCount, 10) || 0, total = q + inCart;
      var tier = cfg.tiers[0]; cfg.tiers.forEach(function (t) { if (total >= t[0]) tier = t; });
      var base = cfg.tiers[0][1], saved = (base - tier[1]) * q;
      var ship = total >= (cfg.freeShipQty || 3);
      out.innerHTML = q + ' × ' + fmt(tier[1]) + ' = <strong>' + fmt(tier[1] * q) + '</strong>' + (saved > 0 ? ' <em>you save ' + fmt(saved) + '</em>' : '') + (ship ? ' <em>+ free shipping</em>' : '');
      if (list) $$('.tiers__row', list).forEach(function (r) { r.classList.toggle('is-current', parseInt(r.dataset.tier, 10) === tier[0]); });
    }
    qty.addEventListener('change', update); qty.addEventListener('input', update);
    /* the product block's own click handler (registered earlier) has already clamped and written the value */
    $$('.qty button').forEach(function (b) { b.addEventListener('click', update); });
    update();
  })();

  /* ---- sale pop-up: once per session, only after the cookie choice is out of the way */
  (function () {
    var promo = $('[data-promo]'); if (!promo || !cfg.promo) return;
    var KEY = 'ck_promo_v1', last = null;
    try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    function focusables() { return $$('a[href], button:not([disabled])', promo).filter(function (el) { return el.offsetParent !== null; }); }
    function close() {
      promo.hidden = true; d.body.classList.remove('has-modal'); d.removeEventListener('keydown', onKey);
      if (last && last.focus) last.focus({ preventScroll: true });
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    function open() {
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      last = d.activeElement; promo.hidden = false; d.body.classList.add('has-modal');
      var first = $('.promo__actions .btn', promo); first && first.focus({ preventScroll: true });
      d.addEventListener('keydown', onKey);
    }
    promo.addEventListener('click', function (e) { if (e.target.closest('[data-promo-close]')) close(); });
    /* consent.js runs after this file, so "is the banner visible right now" is the wrong question.
       Ask whether a choice already exists; if not, wait until the banner has been shown AND put away. */
    var consent = $('.consent'), opened = false;
    function openOnce(delay) { if (opened) return; opened = true; setTimeout(open, delay); }
    function hasChoice() { try { var v = JSON.parse(localStorage.getItem('ck_consent_v1') || 'null'); return !!(v && v.exp > Date.now()); } catch (e) { return false; } }
    if (!consent || (cfg.consent && cfg.consent.enabled === false) || hasChoice()) { openOnce(1800); }
    else {
      var wasShown = !consent.hidden;
      d.addEventListener('clavakit:consent', function () { openOnce(900); });
      new MutationObserver(function (m, obs) {
        if (!consent.hidden) { wasShown = true; return; }
        if (wasShown) { obs.disconnect(); openOnce(900); }
      }).observe(consent, { attributes: true, attributeFilter: ['hidden'] });
    }
  })();

  /* ---- forms: contact + newsletter -------------------------------------------- */
  function setStatus(form, msg, kind) {
    var s = $('.form__status', form); if (!s) return;
    s.textContent = msg; s.setAttribute('data-kind', kind);
  }
  function validate(form) {
    var bad = null;
    $$('[required]', form).forEach(function (el) {
      var err = $('#' + el.id + '-error');
      var ok = el.value.trim() !== '' && (el.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value));
      el.setAttribute('aria-invalid', String(!ok));
      if (err) err.textContent = ok ? '' : (el.type === 'email' ? 'Enter a valid email address.' : 'This field is required.');
      if (!ok && !bad) bad = el;
    });
    return bad;
  }
  $$('form[data-form]').forEach(function (form) {
    var kind = form.dataset.form;
    $$('[required]', form).forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value) validate(form); });
    });
    form.addEventListener('submit', function (e) {
      var hp = $('.form__hp input', form);
      if (hp && hp.value) { e.preventDefault(); setStatus(form, 'Thanks!', 'success'); form.reset(); return; }
      var bad = validate(form);
      if (bad) { e.preventDefault(); setStatus(form, kind === 'contact' ? 'Please check the highlighted fields.' : 'Please enter a valid email address.', 'error'); bad.focus(); return; }
      if (cfg.nativeForms) return;               /* Shopify receives the POST and re-renders with the result */
      e.preventDefault();
      var btn = $('button[type="submit"]', form); if (btn) btn.setAttribute('aria-busy', 'true');
      setTimeout(function () {
        if (btn) btn.removeAttribute('aria-busy');
        setStatus(form, kind === 'contact' ? 'Message sent. We reply within one business day.' : 'You are on the list. Check your inbox for the welcome code.', 'success');
        form.reset();
        form.setAttribute('data-submitted', 'true');
      }, 400);
    });
  });

  /* ---- 404 search: static site searches the two products; Shopify uses /search */
  var srch = $('form[data-search]');
  if (srch && !cfg.nativeForms) {
    srch.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = ($('input', srch).value || '').toLowerCase();
      var to = /skull|ghost|moto|bike|cycl/.test(q) ? 'product-skull-balaclava.html' : 'product-cat-balaclava.html';
      location.href = to;
    });
  }
})();

/* ---- showcase hero: the row glides one step, the print on the model changes. State lives in `active`; place() derives everything. */
(function () {
  var d = document, sh = d.querySelector('[data-showcase]'); if (!sh) return;
  var model = sh.querySelector('[data-sh-model]'), worn = [].slice.call(model.querySelectorAll('img')), items = [].slice.call(sh.querySelectorAll('.sh__item'));
  var nameEl = sh.querySelector('[data-sh-name]'), lineEl = sh.querySelector('[data-sh-line]'), cta = sh.querySelector('[data-sh-cta]'), bar = sh.querySelector('[data-sh-bar]'), count = sh.querySelector('[data-sh-count]');
  var N = items.length, active = 0, token = 0, H = 0, mobile = false, timer = null;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(i) { var im = worn[(i % N + N) % N]; if (!im.getAttribute('src')) im.src = im.getAttribute('data-src'); return im; }
  function measure() { H = model.getBoundingClientRect().height; mobile = window.innerWidth <= 760; }
  function offset(i) { var o = ((i - active) % N + N) % N; return o > N / 2 ? o - N : o; }
  function slot(o) {
    var a = Math.abs(o), s = o < 0 ? -1 : 1, first = H * (mobile ? .42 : .58), step = H * (mobile ? .26 : .34);
    return { x: s * (first + (a - 1) * step * (1 - (a - 1) * .06)), z: -a * 90, ry: -s * Math.min(38, 14 + a * 7), sc: Math.max(.5, 1 - (a - 1) * .13), op: a > (mobile ? 2 : 4) ? 0 : 1 - (a - 1) * .2, blur: a > 2 ? (a - 2) * 1.2 : 0 };
  }
  function place() {
    items.forEach(function (b, i) {
      var o = offset(i), p = o === 0 ? null : slot(o), on = !!(p && p.op > 0);
      b.style.transform = p ? 'translate3d(' + p.x + 'px,0,' + p.z + 'px) rotateY(' + p.ry + 'deg) scale(' + p.sc + ')' : 'translate3d(0,0,0) scale(1.1)';
      b.style.opacity = p ? p.op : 0; b.style.filter = p && p.blur ? 'blur(' + p.blur + 'px)' : ''; b.style.zIndex = 20 - Math.abs(o);
      b.style.pointerEvents = on ? '' : 'none'; b.tabIndex = on ? 0 : -1;
      if (on) b.removeAttribute('aria-hidden'); else b.setAttribute('aria-hidden', 'true');
    });
  }
  function label() {
    var b = items[active];
    lineEl.textContent = b.getAttribute('data-line');
    nameEl.textContent = ''; var s = d.createElement('span'); s.textContent = b.getAttribute('data-name'); nameEl.appendChild(s);
    cta.href = b.getAttribute('data-href'); cta.setAttribute('aria-label', 'Shop the ' + b.getAttribute('data-name') + ' print');
    bar.style.transform = 'translateX(' + active * 100 + '%)';
    count.textContent = ('0' + (active + 1)).slice(-2) + ' / ' + N;
  }
  function show(im) { worn.forEach(function (x) { x.classList.toggle('is-on', x === im); }); }
  function go(next) {
    next = (next % N + N) % N; if (next === active) return;
    var my = ++token; active = next; place(); label(); load(next + 1); load(next - 1);
    var im = load(next);
    function swap() { if (my === token) show(im); }
    if (im.complete && im.naturalWidth) swap(); else im.addEventListener('load', swap, { once: true });
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  items.forEach(function (b, i) { b.addEventListener('click', function () { stop(); go(i); }); });
  sh.querySelector('[data-sh-next]').addEventListener('click', function () { stop(); go(active + 1); });
  sh.querySelector('[data-sh-prev]').addEventListener('click', function () { stop(); go(active - 1); });
  sh.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { stop(); go(active + 1); } else if (e.key === 'ArrowLeft') { stop(); go(active - 1); }
  });
  /* the visitor takes over as soon as the pointer or the keyboard reaches the stage */
  sh.addEventListener('pointerenter', stop); sh.addEventListener('focusin', stop); sh.addEventListener('touchstart', stop, { passive: true });
  var sx = null;
  sh.addEventListener('pointerdown', function (e) { if (!e.target.closest('a,.sh__arrow')) sx = e.clientX; });
  window.addEventListener('pointerup', function (e) {
    if (sx === null) return; var dx = e.clientX - sx; sx = null;
    if (Math.abs(dx) > 40) { stop(); go(active + (dx < 0 ? 1 : -1)); }
  });
  window.addEventListener('resize', function () { measure(); place(); });
  measure(); place(); label(); load(1); load(-1);
  if (!reduce) timer = setInterval(function () { if (!d.hidden && !d.body.classList.contains('has-modal')) go(active + 1); }, 3800);
  /* masks far from the centre and the other portraits arrive after first paint, nearest first */
  function rest() { items.forEach(function (b) { var im = b.querySelector('img[data-src]'); if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src'); }); for (var i = 0; i < N; i++) load(i); }
  if (d.readyState === 'complete') setTimeout(rest, 600); else window.addEventListener('load', function () { setTimeout(rest, 600); });
})();

/* ---- shop: clickable bundle tiers, mix-your-prints picker, cart drawer.
   One cart adapter with two back ends: Shopify's Ajax cart on the live store, a localStorage cart on the static preview.
   Everything is rendered from the normalised cart object, never patched in place. */
(function () {
  var d = document, w = window, cfg = w.CLAVAKIT || {};
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function el(tag, cls, html) { var e = d.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var sym = cfg.currency || '$';
  function fmt(c) { return sym + (c / 100).toFixed(2); }
  var catalog = []; try { catalog = JSON.parse(($('#ck-catalog') || {}).textContent || '[]'); } catch (e) {}
  function entry(id) { return catalog.filter(function (c) { return String(c.id) === String(id); })[0]; }
  var tiers = cfg.tiers || [[1, 1799], [2, 1699], [3, 1499]], freeQty = cfg.freeShipQty || 3;
  function tierFor(n) { var t = tiers[0]; tiers.forEach(function (x) { if (n >= x[0]) t = x; }); return t; }

  /* ---------- cart adapter */
  var live = !!cfg.nativeForms, root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
  }
  function normLive(c) {
    return { count: c.item_count, total: c.total_price, saved: c.total_discount || 0, items: c.items.map(function (i) {
      return { key: i.key, id: i.variant_id, title: i.product_title, variant: i.variant_title, img: i.image, url: i.url, qty: i.quantity, line: i.final_line_price, orig: i.original_line_price };
    }) };
  }
  var DEMO = 'ck_demo_cart_v1';
  function demoRead() { try { return JSON.parse(localStorage.getItem(DEMO) || '[]'); } catch (e) { return []; } }
  function demoWrite(a) { try { localStorage.setItem(DEMO, JSON.stringify(a)); } catch (e) {} }
  function normDemo(a) {
    var n = a.reduce(function (s, i) { return s + i.qty; }, 0), each = tierFor(n)[1], base = tiers[0][1];
    return { count: n, total: n * each, saved: n * (base - each), items: a.map(function (i) {
      var c = entry(i.id) || {}; return { key: i.id, id: i.id, title: c.product || 'Balaclava', variant: c.name || '', img: c.img, url: c.url, qty: i.qty, line: i.qty * each, orig: i.qty * base };
    }) };
  }
  var cart = {
    get: function () { return live ? fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(normLive) : Promise.resolve(normDemo(demoRead())); },
    add: function (items) {
      if (live) return post('cart/add.js', { items: items.map(function (i) { return { id: i.id, quantity: i.qty }; }) }).then(cart.get);
      var a = demoRead(); items.forEach(function (i) { var h = a.filter(function (x) { return x.id === i.id; })[0]; if (h) h.qty += i.qty; else a.push({ id: i.id, qty: i.qty }); });
      demoWrite(a); return Promise.resolve(normDemo(a));
    },
    change: function (key, qty) {
      if (live) return post('cart/change.js', { id: key, quantity: qty }).then(normLive);
      var a = demoRead().map(function (x) { if (x.id === key) x.qty = qty; return x; }).filter(function (x) { return x.qty > 0; });
      demoWrite(a); return Promise.resolve(normDemo(a));
    }
  };

  /* ---------- drawer */
  var drawer, listEl, footEl, msgEl, lastFocus = null, state = null;
  function build() {
    drawer = el('div', 'drawer'); drawer.hidden = true;
    drawer.innerHTML = '<div class="drawer__scrim" data-drawer-close></div>' +
      '<aside class="drawer__panel" role="dialog" aria-modal="true" aria-labelledby="drawer-title" tabindex="-1">' +
      '<header class="drawer__head"><h2 id="drawer-title">Your cart <span data-drawer-count></span></h2><button type="button" class="drawer__x" data-drawer-close aria-label="Close cart"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>' +
      '<div class="drawer__msg" data-drawer-msg aria-live="polite"></div><ul class="drawer__list" data-drawer-list></ul><footer class="drawer__foot" data-drawer-foot></footer></aside>';
    d.body.appendChild(drawer);
    listEl = $('[data-drawer-list]', drawer); footEl = $('[data-drawer-foot]', drawer); msgEl = $('[data-drawer-msg]', drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { close(); return; }
      var b = e.target.closest('[data-line]'); if (!b) return;
      var item = state.items.filter(function (i) { return String(i.key) === b.getAttribute('data-line'); })[0]; if (!item) return;
      var q = b.hasAttribute('data-remove') ? 0 : item.qty + (b.getAttribute('data-step') === '-' ? -1 : 1);
      if (q > 10) return;
      drawer.classList.add('is-busy');
      cart.change(item.key, q).then(render, fail).then(function () { drawer.classList.remove('is-busy'); });
    });
    d.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled])', drawer).filter(function (x) { return x.offsetParent !== null; }); if (!f.length) return;
      if (!drawer.contains(d.activeElement)) { e.preventDefault(); f[0].focus(); }
      else if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
  function fail(e) { msgEl.innerHTML = '<p class="drawer__error">' + esc(e && e.message || 'Something went wrong. Please try again.') + '</p>'; }
  function render(c) {
    state = c; cfg.cartCount = c.count;
    $$('.cart-count').forEach(function (n) { n.textContent = c.count; n.hidden = !c.count; });
    d.dispatchEvent(new CustomEvent('clavakit:cart', { detail: c }));
    if (!drawer) return c;
    $('[data-drawer-count]', drawer).textContent = c.count ? '(' + c.count + ')' : '';
    if (!c.count) {
      msgEl.innerHTML = ''; footEl.innerHTML = '';
      listEl.innerHTML = '<li class="drawer__empty"><p>Your cart is empty.</p><a class="btn btn--primary" href="' + esc(cfg.shopUrl || 'index.html#shop') + '" data-drawer-close>Shop balaclavas</a></li>';
      return c;
    }
    var next = tiers.filter(function (t) { return t[0] > c.count; })[0];
    var pct = Math.min(100, Math.round(c.count / freeQty * 100));
    msgEl.innerHTML = '<p class="drawer__goal">' + (next
      ? 'Add <strong>' + (next[0] - c.count) + ' more</strong> and every balaclava is <strong>' + fmt(next[1]) + '</strong>' + (next[0] >= freeQty ? ' + free shipping' : '')
      : 'Best price unlocked: <strong>' + fmt(tierFor(c.count)[1]) + ' each + free shipping</strong>') + '</p><div class="drawer__bar"><i style="width:' + pct + '%"></i></div>';
    listEl.innerHTML = c.items.map(function (i) {
      var k = esc(i.key);
      return '<li class="drawer__item">' + (i.img ? '<img src="' + esc(i.img) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="drawer__ph"></span>') +
        '<div class="drawer__info"><p class="drawer__title">' + (i.url ? '<a href="' + esc(i.url) + '">' + esc(i.title) + '</a>' : esc(i.title)) + '</p><p class="drawer__variant">' + esc(i.variant) + '</p>' +
        '<div class="drawer__qty"><button type="button" data-line="' + k + '" data-step="-" aria-label="Decrease quantity of ' + esc(i.variant) + '">−</button><span aria-label="Quantity">' + i.qty + '</span><button type="button" data-line="' + k + '" data-step="+" aria-label="Increase quantity of ' + esc(i.variant) + '">+</button>' +
        '<button type="button" class="drawer__remove" data-line="' + k + '" data-remove>Remove</button></div></div>' +
        '<p class="drawer__price">' + (i.orig > i.line ? '<s>' + fmt(i.orig) + '</s>' : '') + '<strong>' + fmt(i.line) + '</strong></p></li>';
    }).join('');
    footEl.innerHTML = (c.saved > 0 ? '<p class="drawer__row drawer__row--save"><span>Bundle savings</span><span>−' + fmt(c.saved) + '</span></p>' : '') +
      '<p class="drawer__row drawer__row--total"><span>Subtotal</span><strong>' + fmt(c.total) + '</strong></p>' +
      '<p class="drawer__note">' + (c.count >= freeQty ? 'Free tracked shipping included.' : 'Shipping calculated at checkout.') + ' Taxes included.</p>' +
      '<a class="btn btn--primary btn--lg drawer__checkout" href="' + esc(live ? root + 'checkout' : (cfg.cartUrl || 'cart.html')) + '">Checkout</a>' +
      '<a class="drawer__view" href="' + esc(cfg.cartUrl || 'cart.html') + '">View full cart</a>';
    if (!drawer.hidden && !drawer.contains(d.activeElement)) $('.drawer__panel', drawer).focus({ preventScroll: true });
    return c;
  }
  function open(c) {
    if (!drawer) build();
    lastFocus = d.activeElement; drawer.hidden = false; d.body.classList.add('has-modal');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); $('.drawer__panel', drawer).focus({ preventScroll: true }); });
    if (c) render(c); else cart.get().then(render, fail);
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open'); d.body.classList.remove('has-modal');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  $$('a[aria-label="Cart"], a[data-open-cart]').forEach(function (a) { a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); open(); }); });
  if (!live) cart.get().then(render);

  /* ---------- product page: one picker. Tap a print to add a piece; the count on the tiles IS the quantity.
     State is `counts` (+ `order`, the sequence pieces were added in); draw() derives tiles, tiers, quantity field and button. */
  var form = $('form[data-cart]'), qty = $('.qty input'), tierList = $('[data-tiers-live]');
  if (!form || !qty || !catalog.length) return;
  var MAX = 10, counts = {}, order = [], handle = cfg.productHandle;
  var radios = $$('.variant-list input');
  function total() { return order.length; }
  function idForRadio(r) {
    var f = r.getAttribute('data-id'); if (f && entry(f)) return String(f);
    var c = catalog.filter(function (x) { return x.handle === handle && (x.key === r.value || x.name === r.getAttribute('data-name')); })[0];
    return c ? String(c.id) : '';
  }
  function radioFor(id) { return radios.filter(function (r) { return idForRadio(r) === String(id); })[0]; }
  var mine = catalog.filter(function (c) { return c.handle === handle; });   /* each product page offers only its own prints; the other cut still counts towards the bundle once it is in the cart */
  function tile(c) {
    var id = esc(c.id), n = esc(c.name);
    return '<div class="pick" data-id="' + id + '"><button type="button" class="pick__add" data-add="' + id + '"><img src="' + esc(c.img) + '" alt="" width="120" height="120" loading="lazy"><span class="pick__name">' + n + '</span></button>' +
      '<span class="pick__n" aria-hidden="true"></span><div class="pick__step"><button type="button" data-sub="' + id + '" aria-label="Remove one ' + n + '">−</button><button type="button" data-add="' + id + '" aria-label="Add one more ' + n + '">+</button></div></div>';
  }
  var picker = el('div', 'picker');
  picker.innerHTML = '<p class="picker__title">Choose your prints</p><p class="picker__hint">Tap a print to add it — tap more to build a bundle.</p>' +
    '<div class="picker__grid" role="group" aria-label="' + esc((mine[0] || {}).product || 'Prints') + '">' + mine.map(tile).join('') + '</div>' +
    '<p class="visually-hidden" aria-live="polite" data-pick-live></p>';
  var fs = $('.variant-list', form); fs = fs && (fs.closest('fieldset') || fs);
  if (fs) { fs.parentNode.insertBefore(picker, fs); fs.hidden = true; } else form.insertBefore(picker, form.firstChild);
  form.classList.add('has-picker');
  var liveEl = $('[data-pick-live]', picker), submitBtns = $$('button[type="submit"]').filter(function (b) { return b.form === form || form.contains(b); });

  function add(id) {
    if (total() >= MAX) return; id = String(id);
    counts[id] = (counts[id] || 0) + 1; order.push(id);
    var r = radioFor(id); if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    draw((entry(id) || {}).name + ' added');
  }
  function sub(id) {
    id = String(id); if (!counts[id]) return;
    counts[id]--; order.splice(order.lastIndexOf(id), 1);
    draw((entry(id) || {}).name + ' removed');
  }
  function draw(msg) {
    var n = total();
    $$('.pick', picker).forEach(function (p) {
      var c = counts[p.getAttribute('data-id')] || 0;
      p.classList.toggle('is-on', c > 0); $('.pick__n', p).textContent = c ? '×' + c : '';
      $('.pick__add', p).setAttribute('aria-label', (c ? 'Add another ' : 'Add ') + $('.pick__name', p).textContent + (c ? ' (' + c + ' selected)' : ''));
    });
    qty.value = Math.max(1, n); $$('input[name="quantity"]').forEach(function (q) { q.value = Math.max(1, n); });
    qty.dispatchEvent(new Event('change', { bubbles: true }));
    var out = $('[data-tier-total]'); if (out && !n) out.textContent = 'Pick at least one print.';
    submitBtns.forEach(function (b) { b.disabled = !n; });
    if (tierList) $$('.tiers__row', tierList).forEach(function (r) {
      var on = parseInt(r.getAttribute('data-tier'), 10) === Math.min(3, n);
      r.setAttribute('aria-checked', on ? 'true' : 'false'); r.tabIndex = on || (!n && r.getAttribute('data-tier') === '1') ? 0 : -1; r.classList.toggle('is-picked', on);
    });
    if (msg && liveEl) liveEl.textContent = msg + '. ' + n + (n === 1 ? ' piece' : ' pieces') + ' selected.';
  }
  picker.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]'), s = e.target.closest('[data-sub]');
    if (s) sub(s.getAttribute('data-sub')); else if (a) add(a.getAttribute('data-add'));
  });
  /* tiers: clicking a row tops the selection up (with the last tapped print) or trims it back to that size */
  if (tierList) {
    tierList.setAttribute('role', 'radiogroup');
    var rows = $$('.tiers__row', tierList);
    rows.forEach(function (r, i) {
      var target = parseInt(r.getAttribute('data-tier'), 10);
      r.setAttribute('role', 'radio'); r.classList.add('is-clickable');
      function pick() {
        var last = order[order.length - 1] || String((mine[0] || catalog[0]).id);
        while (total() < target) add(last);
        while (total() > target) sub(order[order.length - 1]);
      }
      r.addEventListener('click', pick);
      r.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); rows[(i + 1) % rows.length].focus(); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); rows[(i + rows.length - 1) % rows.length].focus(); }
      });
    });
  }
  /* start with the print the visitor arrived for (hash from the hero) or the first one */
  setTimeout(function () {
    var r = radios.filter(function (x) { return x.checked; })[0], id = r && idForRadio(r);
    add(id || String((mine[0] || catalog[0]).id));
  }, 0);

  /* add to cart: always through the adapter, then the drawer slides in; native submit stays as the fallback */
  $$('form[data-cart]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!order.length) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      var ids = order.slice();
      var grouped = {}; ids.forEach(function (x) { grouped[x] = (grouped[x] || 0) + 1; });
      var items = Object.keys(grouped).map(function (k) { return { id: live ? parseInt(k, 10) : k, qty: grouped[k] }; });
      var btns = $$('button[type="submit"]'); btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      cart.add(items).then(function (c) { open(c); }, function (err) { if (live) { f.submit(); } else { open(); fail(err); } })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }, true);
  });
})();
